module.exports = __webpack_public_path__ + "static/media/folder-cfa.30a91175.svg";